import { Controller } from "stimulus"

export default class extends Controller {

  connect() { }
  
  openNativeCamera(event) {
    event.preventDefault();

    if (window.NativeBridge) {
      const success = window.NativeBridge.openBarcodeScanner();
      if (success) {
        console.log("Barcode scanner opened successfully");
        window.localStorage.setItem('scannerState', 'opened');
      } else {
        console.log("Failed to open barcode scanner");
      }
    } else {
      // Fallback to direct WebKit access
      console.log("NativeBridge not available, falling back to WebKit");
    }
  }
}
